import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Moment, parseZone } from 'moment';
import { Subscription } from 'rxjs';
import { Ids } from 'src/app/models/common/ids.model';
import { OrderStatusTag } from 'src/app/models/common/order-status-tag.model';
import { OrdersListFilters } from 'src/app/models/common/orders-list-filters.model';
import { CommonService } from 'src/app/services/common.service';

import { GridColumn, GridColumnTypeEnum } from '../../../models/common/grid-column.models';
import { OrderListItem } from '../../../models/common/order-list-item.model';
import { SidebarTypeEnum } from '../../../models/common/sidebar-type.enum';
import { PhotographerService } from '../../../services/photographer.service';
import { SidenavService } from '../../../shared/services/sidenav.service';
import { TopbarService } from '../../../shared/services/topbar.service';
import { UtilityFunctions } from '../../../shared/utilities/functions.models';

@Component({
  standalone: false,
  selector: 'bt-photographer-order-list',
  templateUrl: './photographer-order-list.component.html',
  styleUrls: ['./photographer-order-list.component.scss']
})
export class PhotographerOrderListComponent implements OnDestroy {

  public currentSidebar: SidebarTypeEnum;
  public sidebarTypeEnum = SidebarTypeEnum;
  public gridColumnTypeEnum = GridColumnTypeEnum;
  public gridColumns: GridColumn[];
  public loaderId = UtilityFunctions.newGuid();

  public orders: { data?: OrderListItem[], page?: number, search?: string, size: number, total?: number } = {
    size: 10
  };
  public statusFilters: { data?: OrderStatusTag[], selectedCached: OrderStatusTag[], selectedCurrent?: OrderStatusTag[], loaderId: string } = {
    selectedCached: [],
    loaderId: UtilityFunctions.newGuid()
  };
  public datesFilters: { fromDateCached?: string, fromDateCurrent?: string, toDateCached?: string, toDateCurrent?: string, notSetDueDate?: boolean, notSetDueDateCurrent?: boolean } = {};

  public orderId: number;
  public orderNumber: string;
  public modelId: number;

  private subscription = new Subscription();

  constructor(
    private _activatedRoute: ActivatedRoute,
    private photoService: PhotographerService,
    private commonService: CommonService,
    private topbarService: TopbarService,
    private sidenavService: SidenavService
  ) {
    this.queryParamsSubscribe()
    this.setGridColumns();
    this.searchTextSubscription();
  }

  public ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  public onOpenFilter() {
    this.currentSidebar = SidebarTypeEnum.filters;
    this.statusFilters.selectedCurrent = UtilityFunctions.DeepClone(this.statusFilters.selectedCached);
    this.datesFilters.fromDateCurrent = UtilityFunctions.DeepClone(this.datesFilters.fromDateCached);
    this.datesFilters.toDateCurrent = UtilityFunctions.DeepClone(this.datesFilters.toDateCached);
    this.datesFilters.notSetDueDateCurrent = this.datesFilters.notSetDueDate;
    this.getOrderStatus();
  }

  public getOrderStatus() {
    this.commonService.getOrderStatus(this.statusFilters.loaderId).subscribe(data => {
      data.forEach(p => p.checked = this.statusFilters.selectedCurrent.some(el => el.orderStatusId === p.orderStatusId));
      this.statusFilters.data = data;
    });
  }

  public applyFilters() {
    this.statusFilters.selectedCached = this.statusFilters.selectedCurrent;
    this.datesFilters.notSetDueDate = this.datesFilters.notSetDueDateCurrent;
    this.datesFilters.fromDateCached = this.datesFilters.notSetDueDate ? null : this.datesFilters.fromDateCurrent;
    this.datesFilters.toDateCached = this.datesFilters.notSetDueDate ? null : this.datesFilters.toDateCurrent;
    this.onExitFilters();
    this.getOrders(0);
  }

  public onExitFilters() {
    this.currentSidebar = null;
    this.statusFilters.data = null;
    this.statusFilters.selectedCurrent = null;
    this.datesFilters.fromDateCurrent = null;
    this.datesFilters.toDateCurrent = null;
  }

  public removeStatusFilter(s: OrderStatusTag) {
    const index = this.statusFilters.selectedCached.findIndex(x => x.orderStatusId === s.orderStatusId);
    this.statusFilters.selectedCached.splice(index, 1);
    this.getOrders(0);
  }

  public clickStatusLabel(s: OrderStatusTag) {
    s.checked = !s.checked;
    this.changeStatusCheckboxValue(s);
  }

  public changeStatusCheckboxValue(s: OrderStatusTag) {
    if (!s.checked) {
      const index = this.statusFilters.selectedCurrent.findIndex(st => st.orderStatusId === s.orderStatusId);
      this.statusFilters.selectedCurrent.splice(index, 1);
    } else {
      this.statusFilters.selectedCurrent.push(s);
    }
  }

  public removeFromDateFilter() {
    this.datesFilters.fromDateCached = null;
    this.getOrders(0);
  }

  public removeToDateFilter() {
    this.datesFilters.toDateCached = null;
    this.getOrders(0);
  }

  public removeWithoutDueDateFilter() {
    this.datesFilters.notSetDueDate = false;
    this.getOrders(0);
  }

  public onInfo(item: OrderListItem) {
    const params: Params = { orderId: item.orderId, orderNumber: item.orderNumber };
    this.sidenavService.newItemUrlPart('order-list', params);
    this.orderId = item.orderId;
    this.orderNumber = item.orderNumber;
    this.orders.data = null;
  }

  public onExitFromInfo() {
    const params: Params = {};
    this.sidenavService.newItemUrlPart('order-list', params);
    this.orderId = null;
    this.orderNumber = null;
    this.getOrders(0);
  }

  public getOrders(page: number) {
    this.orders.page = page;
    // const filters = new OrdersListFilters({
    //   NotSetDueDate: this.datesFilters.notSetDueDate,
    //   PhotographerIds: null,
    //   FromDueDate: this.datesFilters.fromDateCached ? parseZone(this.datesFilters.fromDateCached).utc(true).toISOString() : null,
    //   ToDueDate: this.datesFilters.toDateCached ? parseZone(this.datesFilters.toDateCached).utc(true).toISOString() : null,
    //   OrderStatusIds: this.statusFilters.selectedCached.map(x => new Ids(x.orderStatusId))
    // });
    // this.photoService.getOrders(page, this.orders.size, this.orders.search, false, filters, this.loaderId).subscribe(data => {
    //   this.orders.data = data.orders;
    //   this.orders.total = data.total;
    // });
  }

  private searchTextSubscription() {
    this.subscription.add(this.topbarService.searchTextSubscribe.subscribe(data => {
      if (data !== this.orders.search && !this.orderId && !this.orderNumber) {
        this.orders.search = data;
        this.getOrders(0);
      }
    }));
  }

  private setGridColumns() {
    this.gridColumns = [
      { title: '', field: '', type: GridColumnTypeEnum.icon, width: 20 },
      { title: 'Order #', field: 'orderNumber' },
      { title: 'Status', field: 'orderStatusName' },
      { title: 'Due Date', field: 'dueDate', type: GridColumnTypeEnum.date },
      { title: 'Shots', field: '', type: GridColumnTypeEnum.custom }
    ];
  }

  private queryParamsSubscribe() {
    this.subscription.add(this._activatedRoute.queryParams.subscribe(data => {
      const orderId = data['orderId'];
      this.orderId = !!orderId ? +orderId : null;
      const orderNumber = data['orderNumber'];
      this.orderNumber = orderNumber || null;
      const modelId = data['modelId'];
      this.modelId = !!modelId ? +modelId : null;
      this.orders.search = null;
      if (!this.orderId || !this.orderNumber) {
        this.orderId = null;
        this.orderNumber = null;
        this.getOrders(0);
      } else {
        this.orders.data = null;
      }
    }));
  }
}
